import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/mapto";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as ErrorHandler from "../common/errorHandler";
import * as DTOS from "../FeralScan.dtos";
import { serviceApi } from "../services/usergroup.service";

import {
    GET_USER_GROUP_REQUEST,
    GET_USER_GROUP_SUCCESS,
    IGetUserGroupRequestAction,
    getUserGroupRequestSuccess,
} from "../actions/usergroup.actions";

export const getUserGroup = action$ =>
    action$
        .ofType(GET_USER_GROUP_REQUEST)
        .mergeMap((action: IGetUserGroupRequestAction) =>
            serviceApi
                .getUserGroup(action.userGroupId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getUserGroupRequestSuccess(response.userGroup))
                    )
                })
                .catch((error: DTOS.GetUserGroupResponse) => ErrorHandler.FireErrorActions(error))
        );